import { render, staticRenderFns } from "./PoweredByGoogleWidget.vue?vue&type=template&id=56e9e82c&scoped=true&"
import script from "./PoweredByGoogleWidget.vue?vue&type=script&lang=js&"
export * from "./PoweredByGoogleWidget.vue?vue&type=script&lang=js&"
import style0 from "./PoweredByGoogleWidget.vue?vue&type=style&index=0&id=56e9e82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e9e82c",
  null
  
)

export default component.exports